import { ImageTable } from "../../../../mcleod-ui-common/common/src/imaging/ImageTable";
import { TableComment } from "../../../general/src/TableComment";
import { TableContact } from "../../../general/src/TableContact";
import { GPMappingTable } from "../GPMappingTable";
import { Payee401kRates } from "../Payee401kRates";
import { RecurringPayAdjustmentTable } from "../RecurringPayAdjustmentTable";
import { SegAllocDetailTable } from "../SegAllocDetailTable";
import { TableDirectDeposit } from "../TableDirectDeposit";
import { TableLeave } from "../TableLeave";
import { Button, Checkbox, CityState, DataHeader, DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDrsPayee extends Layout {
    buttonAdjustLeave: Button;
    buttonCarrierFind: Button;
    buttonClearClassification: Button;
    buttonJobClassification: Button;
    buttonOfficePayee: Button;
    checkboxDisablePayrollTaxes: Checkbox;
    checkboxDrsPayeeisFactored: Checkbox;
    checkboxDrsPayeeprintDriverOrdersDtl: Checkbox;
    checkboxDrsPayeetermIsQuickPay: Checkbox;
    checkboxExemptFromFed: Checkbox;
    checkboxExemptFromState: Checkbox;
    checkboxMultipleJobs: Checkbox;
    checkboxNonOfficeEmp: Checkbox;
    checkboxOfficeEmployee: Checkbox;
    checkboxVmPartUpdate: Checkbox;
    citystatePayeeCityId: CityState;
    dataheaderSettlement: DataHeader;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    horizontalspacer3: HorizontalSpacer;
    horizontalspacer4: HorizontalSpacer;
    horizontalspacer5: HorizontalSpacer;
    horizontalspacer6: HorizontalSpacer;
    horizontalspacer7: HorizontalSpacer;
    horizontalspacerYTD: HorizontalSpacer;
    labelContainer: Label;
    labelContributions: Label;
    labelDeductions: Label;
    labelDetentionSingle: Label;
    labelDetentionTeam: Label;
    labelDirectDepositStatusMessage: Label;
    labelDistanceOverride: Label;
    labelDrsPayeeIsQuickPay: Label;
    labelDrsPayeeisFactored: Label;
    labelFact: Label;
    labelFederal: Label;
    labelIsQuickPay: Label;
    labelJobClassification: Label;
    labelLastPeriod: Label;
    labelLeaveHistory: Label;
    labelLocalTaxes: Label;
    labelPickupOverrides: Label;
    labelRates: Label;
    labelS: Label;
    labelSettlementHours: Label;
    labelSettlementYTDHours: Label;
    labelSick: Label;
    labelSingleDriver: Label;
    labelStateTaxes: Label;
    labelTeamDrivers: Label;
    labelTotalHours: Label;
    labelVacation: Label;
    labelVactionTable: Label;
    labelYTDHours: Label;
    labelYTDWages: Label;
    labelYTDWithheld: Label;
    layout401kRates: Payee401kRates;
    layoutContactTable: TableContact;
    layoutDirectDeposit: TableDirectDeposit;
    layoutGPMapping: GPMappingTable;
    layoutImageTable: ImageTable;
    layoutRecurringPayAdjustment: RecurringPayAdjustmentTable;
    layoutSegAllocDetail: SegAllocDetailTable;
    layoutTableComment: TableComment;
    layoutTableLeaveSick: TableLeave;
    layoutTableLeaveVacation: TableLeave;
    panelCheckStubComment: Panel;
    panelContainer: Panel;
    panelContributions: Panel;
    panelDeductions: Panel;
    panelDirectDeposit: Panel;
    panelDistanceContainer: Panel;
    panelFactored: Panel;
    panelFederalTax: Panel;
    panelFederalTaxFields: Panel;
    panelFreeze: Panel;
    panelGeneralOne: Panel;
    panelGeneralThree: Panel;
    panelGeneralTwo: Panel;
    panelJobClassification: Panel;
    panelLeave: Panel;
    panelLeaveHours: Panel;
    panelLeaveTables: Panel;
    panelLocalTax: Panel;
    panelNonDriverYTD: Panel;
    panelOverrides: Panel;
    panelPayToFour: Panel;
    panelPayToMain: Panel;
    panelPayToOne: Panel;
    panelPayToThree: Panel;
    panelPayToTwo: Panel;
    panelRates: Panel;
    panelSettlementHours: Panel;
    panelSettlementStatus: Panel;
    panelSettlementTotalHours: Panel;
    panelSick: Panel;
    panelSingleDriver: Panel;
    panelStateTaxes: Panel;
    panelTeamDrivers: Panel;
    panelTermQuickPay: Panel;
    panelTriumphPay: Panel;
    panelVacation: Panel;
    panelYTDWages: Panel;
    panelYTDWithheld: Panel;
    payeeCheckCityStateZip: CityState;
    sourceComments: DataSource;
    sourceContacts: DataSource;
    sourceDirectDeposit: DataSource;
    sourceDrsPayee: DataSource;
    sourceDrsRecurDeduct: DataSource;
    sourceGPMapping: DataSource;
    sourceLeaveSick: DataSource;
    sourceLeaveVacation: DataSource;
    sourcePayee401krateHdr: DataSource;
    sourceSegAllocDetail: DataSource;
    switchCalcAgentPay: Switch;
    switchEFTForIndividual: Switch;
    switchFreezePay: Switch;
    switchPayAdvances: Switch;
    switchPayFactoringCompany: Switch;
    switchPayeeemailSummary: Switch;
    switchPayeegpExclude: Switch;
    switchPrint1099: Switch;
    switchQuickpayEnabled: Switch;
    switchReimburseFuel: Switch;
    switchW4Status: Switch;
    switchW9OnFile: Switch;
    tab401kRates: Tab;
    tabAccounting: Tab;
    tabAccountingInterface: Tab;
    tabComments: Tab;
    tabContacts: Tab;
    tabDetention: Tab;
    tabDirectDeposit: Tab;
    tabGeneral: Tab;
    tabImages: Tab;
    tabLeave: Tab;
    tabPayDetails: Tab;
    tabPayTo: Tab;
    tabQuickPay: Tab;
    tabRecurringPayAdjustments: Tab;
    tabTaxes: Tab;
    tabTriumphPay: Tab;
    tabYTD: Tab;
    tabsetPayee: Tabset;
    textboxAddFedToWh: Textbox;
    textboxAddlStToWhold: Textbox;
    textboxBoxFor1099Total: Textbox;
    textboxChildContract: Textbox;
    textboxCityAmtToWhold: Textbox;
    textboxCityExemptions: Textbox;
    textboxCityTaxCode: Textbox;
    textboxCode: Textbox;
    textboxCountyAmtToWhold: Textbox;
    textboxCountyExemptions: Textbox;
    textboxCountyTaxCode: Textbox;
    textboxCurrency: Textbox;
    textboxDepartment: Textbox;
    textboxDependents: Textbox;
    textboxDetentionMaxPayAmt: Textbox;
    textboxDetentionPayRate: Textbox;
    textboxDrsPayeebankAcctTypeName: Textbox;
    textboxDrsPayeebankCompleteAddress: Textbox;
    textboxDrsPayeedefaultBankAccount: Textbox;
    textboxDrsPayeedetentionTmEarningCode: Textbox;
    textboxDrsPayeedetentionTmMaxPayAmt: Textbox;
    textboxDrsPayeedetentionTmPayRate: Textbox;
    textboxDrsPayeedistanceProfile: Textbox;
    textboxDrsPayeedivisionId: Textbox;
    textboxDrsPayeedrayRate: Textbox;
    textboxDrsPayeedriverRating: Textbox;
    textboxDrsPayeeemptyPayRate: Textbox;
    textboxDrsPayeeexperienceDate: Textbox;
    textboxDrsPayeefactorName: Textbox;
    textboxDrsPayeefuelReimburseId: Textbox;
    textboxDrsPayeegrossNonTaxed: Textbox;
    textboxDrsPayeeholidayHoursPd: Textbox;
    textboxDrsPayeejobClassCodeId: Textbox;
    textboxDrsPayeeloadedPayRate: Textbox;
    textboxDrsPayeeminimumPay: Textbox;
    textboxDrsPayeenumDaysToPay: Textbox;
    textboxDrsPayeeovertimeCutoff: Textbox;
    textboxDrsPayeeovertimeHoursPd: Textbox;
    textboxDrsPayeeovertimeRate: Textbox;
    textboxDrsPayeepayRateGroup: Textbox;
    textboxDrsPayeeperdiemRate: Textbox;
    textboxDrsPayeeperiodMiles: Textbox;
    textboxDrsPayeepuPayAmount: Textbox;
    textboxDrsPayeeregularHoursPd: Textbox;
    textboxDrsPayeeregularRate: Textbox;
    textboxDrsPayeesickHoursPd: Textbox;
    textboxDrsPayeesoPayAmount: Textbox;
    textboxDrsPayeeteamEmptyRate: Textbox;
    textboxDrsPayeeteamMethod: Textbox;
    textboxDrsPayeeteamPayRate: Textbox;
    textboxDrsPayeetermCode: Textbox;
    textboxDrsPayeeterminalId: Textbox;
    textboxDrsPayeetieredStopId: Textbox;
    textboxDrsPayeetrailerRent: Textbox;
    textboxDrsPayeevacationHoursPd: Textbox;
    textboxDrsPayeevacationPayRate: Textbox;
    textboxDrsPayeeytd401kCatchup: Textbox;
    textboxDrsPayeeytd401kContrib: Textbox;
    textboxDrsPayeeytdCityGross: Textbox;
    textboxDrsPayeeytdCityTaxWh: Textbox;
    textboxDrsPayeeytdCountyWages: Textbox;
    textboxDrsPayeeytdCountyWh: Textbox;
    textboxDrsPayeeytdEttWages: Textbox;
    textboxDrsPayeeytdFedGross: Textbox;
    textboxDrsPayeeytdFedWithheld: Textbox;
    textboxDrsPayeeytdFicaHiGros: Textbox;
    textboxDrsPayeeytdFicaHiWh: Textbox;
    textboxDrsPayeeytdFicaOadiGr: Textbox;
    textboxDrsPayeeytdFicaOadiWh: Textbox;
    textboxDrsPayeeytdFuiGross: Textbox;
    textboxDrsPayeeytdHolidayHrs: Textbox;
    textboxDrsPayeeytdMiles: Textbox;
    textboxDrsPayeeytdOvertimeHrs: Textbox;
    textboxDrsPayeeytdPfmlGross: Textbox;
    textboxDrsPayeeytdPfmlWithheld: Textbox;
    textboxDrsPayeeytdRegHrsPaid: Textbox;
    textboxDrsPayeeytdSdiGross: Textbox;
    textboxDrsPayeeytdSdiWithheld: Textbox;
    textboxDrsPayeeytdSickHrsPaid: Textbox;
    textboxDrsPayeeytdStateGross: Textbox;
    textboxDrsPayeeytdStateWh: Textbox;
    textboxDrsPayeeytdSuiGross: Textbox;
    textboxDrsPayeeytdSuiWithheld: Textbox;
    textboxDrsPayeeytdTotalGross: Textbox;
    textboxDrsPayeeytdVacationHrs: Textbox;
    textboxEarningCode: Textbox;
    textboxEfsAccount: Textbox;
    textboxEftFirstName: Textbox;
    textboxEftLastName: Textbox;
    textboxEftMiddleInitial: Textbox;
    textboxExpenseGlid: Textbox;
    textboxExtraWithholdings: Textbox;
    textboxFactoringCompanyId: Textbox;
    textboxFedAmtToWhold: Textbox;
    textboxFedExemptions: Textbox;
    textboxFedMaritalStatus: Textbox;
    textboxFreezeBy: Textbox;
    textboxFuelSurchargePay: Textbox;
    textboxGrossNonTaxed: Textbox;
    textboxLastRaiseDate: Textbox;
    textboxLoadedPayRate: Textbox;
    textboxMethod: Textbox;
    textboxOffPayeebeginSickDt: Textbox;
    textboxOffPayeebeginVacationDt: Textbox;
    textboxOffPayeesickEarned: Textbox;
    textboxOffPayeesickHoursBase: Textbox;
    textboxOffPayeesickHoursDue: Textbox;
    textboxOffPayeesickLastAccrued: Textbox;
    textboxOffPayeevacAccrualRateSick: Textbox;
    textboxOffPayeevacAccrualRateVac: Textbox;
    textboxOffPayeevacLastAccrued: Textbox;
    textboxOffPayeevacationEarned: Textbox;
    textboxOffPayeevacationHoursDue: Textbox;
    textboxOffPayeevacationHrsBase: Textbox;
    textboxOffPayeewhenSickAccrues: Textbox;
    textboxOffPayeewhenVacAccrues: Textbox;
    textboxOtherDeductions: Textbox;
    textboxOtherIncome: Textbox;
    textboxParentContract: Textbox;
    textboxPayMethod: Textbox;
    textboxPayOption: Textbox;
    textboxPayeCheckStubComment: Textbox;
    textboxPayeeachBatchClassCode: Textbox;
    textboxPayeeaddress1: Textbox;
    textboxPayeeaddress2: Textbox;
    textboxPayeebirthDate: Textbox;
    textboxPayeecheckAddress2: Textbox;
    textboxPayeecheckAddress: Textbox;
    textboxPayeecheckDate: Textbox;
    textboxPayeecheckName: Textbox;
    textboxPayeecheckNumber: Textbox;
    textboxPayeeemail: Textbox;
    textboxPayeegpExported: Textbox;
    textboxPayeegpImported: Textbox;
    textboxPayeehireDate: Textbox;
    textboxPayeelegalName: Textbox;
    textboxPayeename: Textbox;
    textboxPayeephoneNumber: Textbox;
    textboxPayeepostedCheckDate: Textbox;
    textboxPayeesocialSecurityNo: Textbox;
    textboxPayeeterminationDate: Textbox;
    textboxPaymentFrequency: Textbox;
    textboxPaymentMethod: Textbox;
    textboxPeriodMiles: Textbox;
    textboxPrevCode: Textbox;
    textboxProcessStatus: Textbox;
    textboxQuickpayAmount: Textbox;
    textboxQuickpayBasis: Textbox;
    textboxQuickpayContract: Textbox;
    textboxQuickpayDaystopay: Textbox;
    textboxQuickpayDeductId: Textbox;
    textboxQuickpayMinChg: Textbox;
    textboxStAmtToWhold: Textbox;
    textboxStMaritalStatus: Textbox;
    textboxStateExemptions: Textbox;
    textboxStateTaxCode: Textbox;
    textboxStatus: Textbox;
    textboxSuiTaxCode: Textbox;
    textboxTaxTableCityAux: Textbox;
    textboxTaxTableCityMisc: Textbox;
    textboxTaxTableCountyAux: Textbox;
    textboxTaxTableCountyMisc: Textbox;
    textboxTaxTableFitAux: Textbox;
    textboxTaxTableFitMisc: Textbox;
    textboxTaxTableStAux: Textbox;
    textboxTaxTableStMisc: Textbox;
    textboxTaxTableSuiAux: Textbox;
    textboxTaxTableSuiMisc: Textbox;
    textboxTaxableOwed: Textbox;
    textboxTypeOf: Textbox;
    textboxYtdHolidayHrs: Textbox;
    textboxYtdMiles: Textbox;
    textboxYtdOvertimeHrs: Textbox;
    textboxYtdRegHrsPaid: Textbox;
    textboxYtdSickHrsPaid: Textbox;
    textboxYtdTotalGross: Textbox;
    textboxYtdVacationHrs: Textbox;
    textboxhourlyPayAllocation: Textbox;
}
